// Fonction pour obtenir l'URL de l'image
export const getProductImage = (imageId) => {
  // Si c'est un ID GridFS (ObjectId MongoDB), utiliser l'API
  if (imageId && imageId.match(/^[0-9a-fA-F]{24}$/)) {
    const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
    return `${baseUrl}/product-images/${imageId}`;
  }
  
  // Image par défaut si pas d'ID
  return "https://via.placeholder.com/600x700/07004e/5efafa?text=Personal+Regrets";
};

// Fonction pour obtenir toutes les images d'un produit
export const getProductImages = (imageIds) => {
  if (!imageIds || !Array.isArray(imageIds)) {
    return [
      "https://via.placeholder.com/600x700/07004e/5efafa?text=Personal+Regrets",
    ];
  }
  return imageIds.map((id) => getProductImage(id));
};
